import { useState } from "react";
import axios from "axios";
import Result from "./Result";
import "./Dictionary.css";
import Photos from "./Photos";
import Error from "./Error";

export default function Dictionary() {
  let [word, setWord] = useState("");
  let [results, setResults] = useState(null);
  let [photos, setPhotos] = useState(null);
  let [error, setError] = useState(false);

  function handleError() {
    setError(true);
    setResults(null);
  }

  function handleDicResponse(response) {
    setResults(response.data[0]);
    setError(false);
  }

  function handlePexelResponse(response) {
    setPhotos(response.data.photos);
  }

  function submitForm(event) {
    event.preventDefault();
    //https://dictionaryapi.dev
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${word}`;
    axios.get(apiUrl).then(handleDicResponse).catch(handleError);

    let apiKeyPexels =
      "563492ad6f91700001000001826eeaeae5b7419e93721d8e7615e773";
    let headers = {
      Authorization: `Bearer ${apiKeyPexels}`,
    };
    axios
      .get(`https://api.pexels.com/v1/search?query=${word}&per_page=6`, {
        headers: headers,
      })
      .then(handlePexelResponse);
  }

  function updateWord(event) {
    setWord(event.target.value);
  }

  return (
    <div className="Dictionary">
      <h1>Look up a word</h1>
      <form onSubmit={submitForm}>
        <i className="fas fa-search icon"></i>
        <input type="search" onChange={updateWord}></input>
      </form>
      <Error display={error} />
      <Result data={results} />
      <Photos photos={photos} />
    </div>
  );
}
